import { ParameterType } from '@/study-search/enums';

import { FilterDefinition } from './FilterDefinition';
import { CountryFilterOptionInformation } from '@studyportals/search-filters';
import CountryfilterOptionInformationFactory from '../filter/location/country/CountryfilterOptionInformationFactory';

export class CountryFilterDefinition extends FilterDefinition {
	public constructor() {
		super(
			ParameterType.COUNTRY,
			CountryfilterOptionInformationFactory.getCountryFilterInformation(),
			CountryfilterOptionInformationFactory.getCountryFilterOptionValues(),
		);
	}

	public isEea(countryId: string): boolean {
		const countryOptionValue = (this.filterInformation as CountryFilterOptionInformation[]).find((_) => _.optionValue === countryId);

		if (countryOptionValue !== undefined) {
			return countryOptionValue.eea;
		}

		return false;
	}
}
